export default "__VITE_ASSET__CIPrSnNz__"